<template >
  <div class="catogory_group" v-if="category ">
    <div class="cat_title_wrap clearfix">
      <h2 class="right cat_title">
        <router-link :to="{ path: category.link }">{{ category.name }}</router-link>
      </h2>
      <div class="right bt_cat ease">
        <router-link :to="{ path: category.link }">הצג הכל ({{ productsLenght }})</router-link>
      </div>
    </div>
    <div class="cat_slide_wrap small-arrows">
      <div class="arrow_r ease" style="display:none"  :class="'ar_'+category.id">
        <a href="javascript:void(0);" @click.prevent="prev();">
          <arrowRight />
        </a>
      </div>
      <div class="arrow_l ease" style="display:none" :class="'al_'+category.id">
        <a href="javascript:void(0);" @click.prevent="next();">
          <arrowLeft />
        </a>
      </div>
      <div class="cat_slide clearfix " >
        <div v-show="showSlider">

        <slick
          ref="slick"
          :options="slickOptions"
          @reInit="handleReInit"
          v-if="products && slickOptions.nextArrow && slickOptions.prevArrow "
        >
          <Product
            ref="productComponent"
            v-bind:category="category"
            v-bind:product="product"
            v-bind:index="index"
            v-for="(product, index) in filteredList(products)"
            :key="product.id"
          ></Product>
        </slick>
        </div>
        <div class="loader" v-show="!showSlider">
              <img :src="loaderGif" />
        </div>
      <!-- <div class="cat_slide clearfix" v-if="onsale">

        <Product 
          ref="productComponent"
          v-bind:category="category"
            v-bind:product="product"
            v-bind:index="index"
            v-for="(product, index) in filteredList(products)"
            :key="product.id"></Product>  -->
      </div>
    </div>
  </div>
</template>
<script>
import Product from "../components/Product/Product";
//const Product = () => import (/* webpackChunkName: "product" */ '../components/Product/Product.vue');
import arrowLeft from "../assets/img/arrow_l.svg";
import arrowRight from "../assets/img/arrow_r.svg";
import Slick from "vue-slick";

import { mapGetters } from "vuex";

export default {
  props: ["category", "onsale"],
  data() {
    return {
        loaderGif: wpData.assets_url + "/layout/loader.gif",
      slickOptions: {
        slidesToShow: 6,
        slidesToScroll: 3,
        rtl: true,
        infinite: false,
        arrows: true,
        sliderLoaded: false,
        nextArrow: false,
        prevArrow: false,
        responsive: [
          {
            breakpoint: 1200,
            settings: {
              slidesToShow: 5
            }
          },
          {
            breakpoint: 800,
            settings: {
              slidesToShow: 4
            }
          }
        ]
      }
    };
  },
  updated() {
    var p_refs = this.$refs.productComponent;
    this.sendImmpressionsProducts(p_refs);
    //this.showSlider = true;
  },
  mounted() {
    let id = this.category.id;
    let r_arrow = $(".ar_" + id);
    let l_arrow = $(".al_" + id);

    this.slickOptions.nextArrow = l_arrow;
    this.slickOptions.prevArrow = r_arrow;
  },

  computed: {
    ...mapGetters(["productsByCat"]),
    products() {
      
      var productsFound = this.productsByCat[this.category.id];
      // var productsFound = this.$store.state.products.filter(p =>
      //   p.categories.includes(this.category.id)
      // );
      return productsFound;
    },
    productsLenght(){
      if (typeof this.products != "undefined" && this.products) {
        return this.products.length;
      }
      return 0;
    },
    showSlider(){
      if (this.productsLenght) {
        return true;
      }
      return false;
    }
  },
  watch: {
    products: function(value) {
        this.$nextTick(() => {
        if( typeof value !='undefined' && value.length > 0 && typeof this.$refs.slick != 'undefined' && this.$refs.slick){            
          let currIndex = this.$refs.slick.currentSlide();
          this.$refs.slick.destroy();
    
          this.$refs.slick.create();
          this.reInit();
          this.$refs.slick.goTo(currIndex, true);
          this.sliderLoaded = true;
          
        }
      });
    }
  },
  methods: {
    filteredList(items) {
      // if (this.onsale) {
      //   return items
      //     .filter(product => {
      //       return product.onsale;
      //     })
      //     .slice(0, 20);
      // }
      this.$root.$emit('productsSliderLoaded');
      return items.slice(0, 10);
    },
    next() {
      //this.$refs.slick.next();
    },
    prev() {
      //  this.$refs.slick.prev();
    },
    reInit() {
      // Helpful if you have to deal with v-for to update dynamic lists
      this.$nextTick(() => {
        this.$refs.slick.reSlick();
      });
    },
    handleReInit(event, slick) {
      this.reInit();
    }
  },
  components: {
    Product,
    arrowLeft,
    arrowRight,
    Slick
  }
};
</script>
